/**
 * Application configuration.
 *
 * Values are read from window.__CONFIG__ (injected at runtime by the hosting
 * environment) or fall back to Vite environment variables for local development.
 */

interface AppConfig {
  cognitoRegion: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  redirectUri: string;
  mcpEndpointUrl: string;
}

declare global {
  interface Window {
    __CONFIG__?: Partial<AppConfig>;
  }
}

function env(key: string): string {
  return (import.meta as unknown as Record<string, Record<string, string>>).env?.[key] ?? '';
}

const windowCfg = (typeof window !== 'undefined' && window.__CONFIG__) || {};

const config: AppConfig = {
  cognitoRegion: windowCfg.cognitoRegion || env('VITE_COGNITO_REGION') || 'us-east-1',
  userPoolId: windowCfg.userPoolId || env('VITE_USER_POOL_ID') || '',
  userPoolClientId: windowCfg.userPoolClientId || env('VITE_USER_POOL_CLIENT_ID') || '',
  cognitoDomain: windowCfg.cognitoDomain || env('VITE_COGNITO_DOMAIN') || '',
  redirectUri: windowCfg.redirectUri || env('VITE_REDIRECT_URI') || window.location.origin,
  mcpEndpointUrl: windowCfg.mcpEndpointUrl || env('VITE_MCP_ENDPOINT_URL') || 'https://d1ki5w6pod2yva.cloudfront.net/atlassian-admin/mcp',
};

export const API_BASE = '/api';

export default config;
